import { render, staticRenderFns } from "./PageManageRecurring.vue?vue&type=template&id=b0fb32d4&"
import script from "./PageManageRecurring.vue?vue&type=script&lang=ts&"
export * from "./PageManageRecurring.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports